<div class="bg-container">
  <div [translate] class="login-container">
    <main id="content" class="widget-login-container">
      <div class="l-align-x login-panel">
        <spinner *ngIf="showSpinner"></spinner>
        <section class="t-widget login-box" *ngIf="showLogin">
          <header class="l-align-x login-top">
            <img class="logo" src="assets\img\Logo_Horizontal.svg" />
          </header>

          <lang-switch></lang-switch>

          <form class="widget-body">
            <div id="login_details_label" class="welcome-lbl">
              <p>{{ "translate.login.instruct1" | translate }}</p>
              <p>{{ "translate.login.instruct2" | translate }}</p>
              <p>{{ "translate.login.instruct3" | translate }}</p>
              <p>{{ "translate.login.instruct4" | translate }}</p>
              <p>{{ "translate.login.instruct5" | translate }}</p>
            </div>

            <div
              aria-labelledby="login_details_label"
              autocomplete="off"
              class="login-details"
            >
              <div class="t-row--med">
                <input
                  #userNameInput
                  name="userName"
                  type="text"
                  [(ngModel)]="typedUserName"
                  class="t-row--med t-input t-input--colored"
                  placeholder="{{ 'translate.login.userName' | translate }}"
                  attr.aria-label="{{ 'translate.login.userName' | translate }}"
                />

                <div class="l-pos-relative t-row--med">
                  <input
                    #loginIputPassword
                    name="password"
                    type="password"
                    [(ngModel)]="password"
                    class="l-cell-spread-x t-input t-input--colored"
                    placeholder="{{
                      'translate.login.passwordPlaceholder' | translate
                    }}"
                    attr.aria-label="{{
                      'translate.login.passwordPlaceholder' | translate
                    }}"
                    (keyup)="allowShowPassBtn = true"
                  />

                  <ng-container *ngIf="allowShowPassBtn">
                    <a
                      tabIndex="0"
                      class="l-align-center h-full c-grey-med login-btn-showPassword"
                      (click)="showPassword($event)"
                    >
                      <i class="fas fa-eye"></i>
                    </a>
                  </ng-container>
                </div>

                <div class="remember-me-container l-align-spaceBetween t-small">
                  <checkbox-wrap
                    label="{{ 'translate.login.rememberMe' | translate }}"
                  >
                    <input
                      type="checkbox"
                      name="rememberMe"
                      [(ngModel)]="rememberMe"
                    />
                  </checkbox-wrap>

                  <div class="t-buttonSet--med login-password-forgot">
                    <a class="t-small fw-bold" (click)="forgotPassword()">
                      {{ "translate.login.forgotPassword" | translate }}
                    </a>
                  </div>
                </div>
              </div>

              <button
                (click)="login($event)"
                class="login-btn t-button t-button--flat l-ta-center"
              >
                {{ "translate.login.loginButton" | translate }}
              </button>
            </div>
          </form>
        </section>
      </div>
    </main>

    <custom-popup></custom-popup>
    <loader *ngIf="generalLoader"></loader>
  </div>
</div>
